var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"statusIcon",attrs:{"src":_vm.imagePath,"alt":_vm.imageText,"title":_vm.imageText}})
}
var staticRenderFns = []

export { render, staticRenderFns }